  <div class="field">
    <label *ngIf="showLabel" for="docname" class="do-not-wrap-text">{{labelKey}}</label>
    <div class="p-inputgroup">
      <p-button icon="pi pi-external-link" styleClass="p-button-warning mr-1" (onClick)="onDocumentOpenButton($event)" [disabled]="!isThereSelection || disabled"
              pTooltip="Открыть документ в новой вкладке" tooltipPosition="top" ></p-button>
      <p-autoComplete id="docname"
                      [(ngModel)]="selectedDocStr"
                      [suggestions]="docSearchResults"
                      (completeMethod)="doSearch($event)"
                      (onSelect)="onDocumentAutoCompleteSelect($event)"
                      [minLength]="4"
                      [placeholder]="placeholder"
                      [disabled]="disabled"
                      [appendTo]="'body'"
                      (keydown)="$event.stopPropagation()">
        <ng-template let-doc pTemplate="item">
          {{ formatFastSearchResult(doc) }}
        </ng-template>
      </p-autoComplete>
      <p-button icon="pi pi-ban" styleClass="p-button-danger ml-1" (onClick)="onDocumentResetButton($event)" [disabled]="!documentId || disabled"
              pTooltip="Очистить" tooltipPosition="top" ></p-button>
      <p-button icon="pi pi-sitemap" styleClass="p-button-help ml-1" (onClick)="onDocumentTreeButton($event)" [disabled]="!selectedDoc || disabled"
              pTooltip="Дерево документов" tooltipPosition="top" ></p-button>
      <app-documents-tree [(display)]="displayDC"
                          [documentId]="selectedDocId"
                          [disabled]="disabled"
                          (selectedDocument)="onSelectDocumentTreeNode($event)"></app-documents-tree>
      <p-button icon="pi pi-search-plus" styleClass="p-button-success ml-1" (onClick)="onDocumentSearchButton($event)" [disabled]="disabled"
              pTooltip="Поиск документов" tooltipPosition="top" ></p-button>
      <app-documents-search [(display)]="displayDS" (selectedDocument)="onDocumentSearch($event)"></app-documents-search>
    </div>
  </div>

